var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "loading-spinner",
    class: [
      _vm.getPosition == "absolute" ? "loading-spinner--absolute" : "",
      _vm.right ? "loading-spinner--right" : "",
      _vm.left ? "loading-spinner--left" : "",
    ],
    attrs: { title: _vm.getMessage },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }